import { Injectable } from '@angular/core';

interface Push {
  title: string;
  body?: string;
  url?: string;
}

@Injectable({
  providedIn: 'root',
})
export class PusherService {
  constructor() {
    Notification.requestPermission();
  }

  push(push: Push): void {
    if (Notification.permission === 'granted') {
      const notification = new Notification(push.title, {
        tag: 'crm-notification',
        body: push.body,
      });
      if (push.url) {
        // eslint-disable-next-line functional/immutable-data
        notification.onclick = () => {
          event.preventDefault();
          window.open(push.url, '_blank');
        };
      }
    } else {
      console.warn('Notification permission denied');
    }
  }
}
